<template>
    <div class="default-user-icon">
        <div class="circle" />
        <div class="half-circle" />
    </div>
</template>
<script>
    import './DefaultUserIcon.scss';

    export default {
        name: 'DefaultUserIcon',
        props: {
            size: {
                type: Number,
                default: 2,
                required: false,
            }
        },
        mounted() {
            this.setSize();
        },
        methods: {
            setSize() {
                this.$el.style.width = this.size + 'rem';
                this.$el.style.height = this.size + 'rem';
            }
        }
    };
</script>
